module.exports = __webpack_public_path__ + "static/media/home-contracting-1.6a1581a1.jpg";